import request from "@/config/_request";

const postRestArgs = (params, admin = true) => ({
    data: params,
    method: "post",
    headers: {
        "Content-Type": "application/json",
    },
    admin,
})

/**
* mini webview 作品管理-上课创作/课后挑战-详情
* @param {*} params 
* @returns 
*/
export function api_selectTchWorkDetail(params) {
    return request({
        url: "/java-api/weChatMini/work/selectTchWorkDetail",
        ...postRestArgs(params, false)
    });
}

/**
* mini webview 作品管理-上课创作/课后挑战-C++-详情
* @param {*} params 
* @returns 
*/
export function api_selectCppWorkDetail(params) {
    return request({
        url: "/java-api/weChatMini/work/selectCppWorkDetail",
        ...postRestArgs(params, false)
    });
}

/**
* mini webview 作品管理-自由创作-详情
* @param {*} params 
* @returns 
*/
export function api_selectWorkDetail(params) {
    return request({
        url: "/java-api/weChatMini/work/selectWorkDetail",
        ...postRestArgs(params, false)
    });
}
/**
* mini webview H5信息查询
* @param {*} params 
* @returns 
*/
export function api_selectH5(params) {
    return request({
        url: "/java-api/weChatMini/work/selectH5",
        ...postRestArgs(params, false)
    });
}